import React, {useState, useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import styled from 'styled-components';
import Modal from '../../Modal/Modal';
import env from '../../../../util/env';
import {labels} from '../../../../util/utils';
import {independenceActions} from '../../../../util/uiconstants';
import TextAreaEditorWrapper from '../../TextAreaEditor/TextAreaEditor';
import EllipsesControl from '../../EllipsesControl/EllipsesControl';
import {submitIndependenceAction} from '../../../../actions/FormData/formdataactions';
import {useDocumentId, useEngagementId} from '../../../../util/customHooks';
import {getTaskDocumentByDocumentId} from '../../../../selectors/Ares/selectors';

export default function IndependenceModal(props) {
	const {
		independenceComments,
		btnType,
		showModal,
		setShowIndependenceModal,
		setShowIndependenceLoading,
		setActiveIndex
	} = props;

	const [commentText, setCommentText] = useState(independenceComments),
		[showCommentTextError, setShowCommentTextError] = useState(false),
		[titleLabel, setTitleLabel] = useState(''),
		[descLabel, setDescLabel] = useState('');

	const engagementId = useEngagementId();
	const documentId = useDocumentId();
	const maxCommentTextLength = 4000;

	const formData = useSelector((state) => getTaskDocumentByDocumentId(state, documentId)),
		quickLink = useSelector((store) => store.quickLink);

	const dispatch = useDispatch();

	const handleCommentTextChange = (e) => {
		let text = e.currentTarget.value;
		setCommentText(text);
		if(text?.trim().length > 0) {
			setShowCommentTextError(false);
		}
	};

	const renderRequiredErrorMessage = () => {
		return (
			<EllipsesControl content={labels.rationaleTextRequired} tooltip={labels.rationaleTextRequired} noOfLines={1} />
		);
	};

	const onClose = () => {
		setShowIndependenceModal(false);
		setShowCommentTextError(false);
		//reset independence Comment when closed manually.
		setCommentText(independenceComments);
		setActiveIndex(0);
	};

	const onActionClick = () => {
		if (commentText && commentText.trim() !== '') {
			setShowCommentTextError(false);
			submitIndependence();
		} else {
			setShowCommentTextError(true);
		}
	};

	const submitIndependence = () => {
		setShowIndependenceLoading(true);
		let operationType = '';
		switch (btnType) {
			case labels.override:
				{
					operationType = independenceActions.override;
				}
				break;
			case labels.grantAccess:
				{
					operationType = independenceActions.grant;
				}
				break;
			case labels.denyAccess:
				{
					operationType = independenceActions.deny;
				}
				break;
		}

		const data = {
			independenceComment: commentText
		};

		dispatch(submitIndependenceAction(engagementId, formData?.externalStreamId, operationType, data))
			.then(() => {
				setShowIndependenceLoading(false);
				navigateToIndependenceSummary();
				setShowIndependenceModal(false);
				setActiveIndex(0);
			})
			.catch(() => {
				setCommentText(independenceComments);
				setShowIndependenceLoading(false);
				setShowIndependenceModal(false);
				setActiveIndex(0);
			});
	};

	const navigateToIndependenceSummary = () => {
		const url =
			env.getURL('hercules_web') +
			'/smartscreens/independence?engagementid=' +
			engagementId +
			'&documentid=' +
			quickLink.independenceSummaryDocId;

		window.location.href = url;
	};

	useEffect(() => {
		switch (btnType) {
			case labels.override:
				{
					setTitleLabel(labels.override);
					setDescLabel(labels.overrideSmall);
				}
				break;
			case labels.grantAccess:
				{
					setTitleLabel(labels.grantAccess);
					setDescLabel(labels.grantAccessSmall);
				}
				break;
			case labels.denyAccess:
				{
					setTitleLabel(labels.denyAccess);
					setDescLabel(labels.denyAccessSmall);
				}
				break;
		}
	}, [btnType]);

	return (
		<Modal
			show={showModal}
			title={titleLabel}
			modalsize={'medium'}
			onHide={onClose}
			showButtons
			onOkClick={onActionClick}
			confirmBtnTitle={titleLabel}
			closeBtnTitle={labels.cancelButtonLabel}
			closeTitle={labels.cancelButtonLabel}
		>
			<StyledIndependenceModal className="StyledIndependenceModal customScrollbar">
				<section className="IndependenceBodyDesc">{labels.enterRationaleText + ' ' + descLabel}</section>
				<TextAreaEditorWrapper
					showCounter
					textAreaError={showCommentTextError}
					textAreaErrorMessage={renderRequiredErrorMessage()}
					value={commentText}
					maxLength={maxCommentTextLength}
					onChange={handleCommentTextChange}
					textAreaEditorLabel={labels.requiredRationaleText}
				/>
			</StyledIndependenceModal>
		</Modal>
	);
}

const StyledIndependenceModal = styled.section`
	padding: 0 var(--px-20);
	height: 100%;
	.IndependenceBodyDesc {
		font-size: var(--px-14);
		font-weight: 300;
	}
	.showCounterLabelWrapper {
		justify-content: flex-end;
	}
	.motif-input-component {
		.motif-textarea-clear-button {
			top: 3% !important;
		}
	}
	textarea {
		min-height: var(--px-640) !important;
		@media only screen and (max-width: 1366px) {
			min-height: var(--px-440) !important;
		}
	}
`;
